import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/common-banner-bg-BMBchR2h.jpg'
import { useIntl } from 'react-intl';

const TravBusinessPrivacyPolicyPage: React.FC = () => {
  const intl = useIntl();
const tocItems: ITableOfContentItem[] = [
  { id: 'introduction', title: intl.formatMessage({ id: 'privacy.policy.introduction.title' }) },
  { id: 'data-collection', title: intl.formatMessage({ id: 'privacy.policy.dataCollection.title' }) },
  { id: 'retention-deletion', title: intl.formatMessage({ id: 'privacy.policy.retentionDeletion.title' }) },
  { id: 'acceptance-conditions', title: intl.formatMessage({ id: 'privacy.policy.acceptanceConditions.title' }) },
  { id: 'legal-obligation', title: intl.formatMessage({ id: 'privacy.policy.legalObligation.title' }) },
  { id: 'further-information', title: intl.formatMessage({ id: 'privacy.policy.furtherInformation.title' }) },
];


  const sections: IContentSection[] = [
    {
      id: 'introduction',
      title: intl.formatMessage({ id: 'privacy.policy.introduction.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'privacy.policy.introduction.paragraph1' }),
        intl.formatMessage({ id: 'privacy.policy.introduction.paragraph2' }),
        intl.formatMessage({ id: 'privacy.policy.introduction.paragraph3' }),
      ],
    },
    {
      id: 'data-collection',
      title: intl.formatMessage({ id: 'privacy.policy.dataCollection.title' }),
      subSections: [
        {
          subTitle: 'General',
          paragraphs: [
            intl.formatMessage({ id: 'privacy.policy.dataCollection.general.paragraph1' }),
          ],
        },
        {
          subTitle: 'Website Visitors',
          paragraphs: [
            intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.paragraph1' }),
            intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.paragraph2' }),
            intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.paragraph3' }),
            intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.paragraph4' }),
            intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.paragraph5' }),
            
          ],
          subSections: [
            {
              subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.purposeProcessing.subTitle' }),
              paragraphs: [
                intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.purposeProcessing.paragraph1' }),
                intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.purposeProcessing.paragraph2' }),
                
              ]
            },
            {
              subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.sharingPersonalData.subTitle' }),
              paragraphs: [
                intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.sharingPersonalData.paragraph1' }),
              ]
            },
            {
              subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.cookies.subTitle' }),
              paragraphs: [
                intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.cookies.paragraph1' }),
              ]
            },
            {
              subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.linksToOtherSites.subTitle' }),
              paragraphs: [
                intl.formatMessage({ id: 'privacy.policy.dataCollection.websiteVisitors.linksToOtherSites.paragraph1' }),
              ]
            },
          ]
        },
        {
          subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.user.subTitle' }),
          paragraphs: [
            intl.formatMessage({ id: 'privacy.policy.dataCollection.user.paragraph1' }),
          ],
          subSections: [
            {
              subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.user.general.subTitle' }),
              paragraphs: [
                intl.formatMessage({ id: 'privacy.policy.dataCollection.user.general.paragraph1' }),
              ]
            },
            {
              subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.user.collectionUserData.subTitle' }),
              paragraphs: [
                intl.formatMessage({ id: 'privacy.policy.dataCollection.user.collectionUserData.paragraph1' }),
                intl.formatMessage({ id: 'privacy.policy.dataCollection.user.collectionUserData.paragraph2' }),
                
              ]
            },
            {
              subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.user.geographicalLocation.subTitle' }),
              paragraphs: [
                intl.formatMessage({ id: 'privacy.policy.dataCollection.user.geographicalLocation.paragraph1' }),
              ],
              subSections: [
                {
                  subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.user.geographicalLocation.specificProcessingEEA.subTitle' }),
                  paragraphs: [
                    intl.formatMessage({ id: 'privacy.policy.dataCollection.user.geographicalLocation.specificProcessingEEA.paragraph1' }),
                  ]
                },
                {
                  subTitle: intl.formatMessage({ id: 'privacy.policy.dataCollection.user.geographicalLocation.controller.subTitle' }),  
                  paragraphs: [
                    intl.formatMessage({ id: 'privacy.policy.dataCollection.user.geographicalLocation.controller.paragraph1' }),
                    intl.formatMessage({ id: 'privacy.policy.dataCollection.user.geographicalLocation.controller.paragraph2' }),
                  ]
                },
              ]
            },
          ]
        },
      ],
    },
    {
      id: 'retention-deletion',
      title: intl.formatMessage({ id: 'privacy.policy.retentionDeletion.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'privacy.policy.retentionDeletion.paragraph1' }),
      ],
    },
    {
      id: 'acceptance-conditions',
      title: intl.formatMessage({ id: 'privacy.policy.acceptanceConditions.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'privacy.policy.acceptanceConditions.paragraph1' }),
      ],
    },
    {
      id: 'legal-obligation',
      title: intl.formatMessage({ id: 'privacy.policy.legalObligation.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'privacy.policy.legalObligation.paragraph1' }),
      ],
    },
    {
      id: 'further-information',
      title: intl.formatMessage({ id: 'privacy.policy.furtherInformation.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'privacy.policy.furtherInformation.paragraph1' }),
        intl.formatMessage({ id: 'privacy.policy.furtherInformation.addressLine1' }),
        intl.formatMessage({ id: 'privacy.policy.furtherInformation.addressLine2' }),
        intl.formatMessage({ id: 'privacy.policy.furtherInformation.addressLine3' }),
      ],
    },
  ];

  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'privacy.policy.headerTitle' })}
        headerSubtitle={intl.formatMessage({ id: 'privacy.policy.headerSubtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='center'
      />
    </div>
  );
};

export default TravBusinessPrivacyPolicyPage;
